export default __webpack_public_path__ + "static/media/blank.4909cbc4.svg";